"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFusionUrl = void 0;
const buildFusionUrl = (params, brand) => {
    let paramsString = params.toString();
    const hasDestinationUrl = params.has('destinationURL') && params.get('destinationURL')?.trim() !== '';
    // popular destinations is fed through as a feature
    const isPopularDestination = params.has('features') && params.get('features')?.trim() !== '';
    if (!isPopularDestination && hasDestinationUrl) {
        const destinationURL = decodeURI(params.get('destinationURL') ?? '');
        // Temporary solution to support Hoseasons RHS2 levels.
        // Hoseasons use ?region for RHS2 and ?regionId for every other level.
        if (brand === 'hoseasons') {
            paramsString = `${paramsString}&region=${params.get('regionId')}`;
        }
        // append the query params to the destinationURL
        const joiningCharacter = destinationURL.includes('?') ? '&' : '?';
        return `${destinationURL}${joiningCharacter}${paramsString}`;
    }
    const accommodationType = params.get('accommodationType');
    return `/${accommodationType}/all-regions?${paramsString}`;
};
exports.buildFusionUrl = buildFusionUrl;
//# sourceMappingURL=buildFusionUrl.js.map